import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

export default function withRouter(Child) {
  // eslint-disable-next-line
  return (props) => {
    const location = useLocation();

    const navigate = useNavigate();

    const params = useParams();

    const [searchParams, setSearchParams] = useSearchParams();

    const linkTo = (path, linkParams = {}) => {
      navigate(path, linkParams);
    };

    return (
      <Child
        {...props}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
        navigate={linkTo}
        location={location}
        params={params}
      />
    );
  };
}
